<template>
  <svg
    fill="currentColor"
    height="12"
    viewBox="0 0 12 12"
    width="12"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.925 6.45L10.5 3.6V0.75H1.5V3.6L0.075 6.45C0 6.525 0 6.6 0 6.75V11.25H1.5V9H10.5V11.25H12V6.75C12 6.6 12 6.525 11.925 6.45ZM10.425 6.75H1.575L2.7 4.5H9.3L10.425 6.75Z" />
  </svg>
</template>
